// extracted by mini-css-extract-plugin
export default {"root":"EnthusiastPolicyAlert_root__1Gqc3","boldMessage":"EnthusiastPolicyAlert_boldMessage__QGn4i","message":"EnthusiastPolicyAlert_message__nPPre"};